import { useMemo } from 'react';

export const useTentStatus = (tent) => {
    return useMemo(() => {
        if (
            !tent ||
            !tent.staffs ||
            !tent.participants ||
            tent.capacity == null
        ) {
            return {
                status: 'PROBLEMATIC',
                reason: 'N/A',
            };
        }

        const capacity = parseInt(tent.capacity);
        if (isNaN(capacity)) {
            return {
                status: 'PROBLEMATIC',
                reason: 'Tent capacity is not a valid number.',
            };
        }

        const normalizeRole = (role) => role?.toUpperCase?.() ?? '';

        const supervisors = tent.staffs.filter(
            (staff) => normalizeRole(staff.role) === 'SUPERVISOR'
        );

        const assistants = tent.staffs.filter(
            (staff) => normalizeRole(staff.role) === 'ASSISTANT'
        );

        const totalTentPeople = tent.staffs.length + tent.participants.length;

        if (totalTentPeople > capacity) {
            return {
                status: 'PROBLEMATIC',
                reason: 'Tent has more people assigned to it than it can hold.',
            };
        }

        if (supervisors.length === 0) {
            return {
                status: 'PROBLEMATIC',
                reason: 'Tent has no supervisor assigned.',
            };
        }

        if (supervisors.length > 1) {
            return {
                status: 'PROBLEMATIC',
                reason: 'Tent has multiple supervisors assigned.',
            };
        }

        if (assistants.length === 0) {
            return {
                status: 'PROBLEMATIC',
                reason: 'Tent has no assistant(s) assigned.',
            };
        }

        return {
            status: 'OKAY',
            reason: null,
        };
    }, [tent, tent?.participants]); // Added tent?.participants to the dependency array
};
